<template>
    <div class="index">
        <div class="top" >
            <el-steps :active="stepsActive" simple finish-status="process" process-status="finish" style="width:900px;margin-left:20px">
                <el-step title="待接收" :icon="stepsActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="待派工" :icon="stepsActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="调查中" :icon="stepsActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="待审核" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="已提交" :icon="stepsActive>4?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="审核退回" :icon="stepsActive>5?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="完成" :icon="stepsActive>6?'el-icon-folder-checked':'el-icon-edit'"></el-step>
            </el-steps>
            <div style="margin-right:10px">
                <el-button type="primary" icon="el-icon-edit-outline" @click="isApplyDispatchTip = true" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">申请加派/延期</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" v-if="stepsActive==0" @click="receiveAnXinDcTaskTip">接受</el-button>
                <el-button type="warning" icon="el-icon-edit-outline" v-if="stepsActive==0" @click="backForUpdateTip">拒绝</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" v-if="(stepsActive==3||stepsActive==5)&&detailData.sourceType!=1" @click="doubtTaskCompleteTip">提交安心</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" v-if="(stepsActive==3||stepsActive==5)&&detailData.sourceType==1" @click="passAuditTip">审核通过</el-button>
                <el-button type="warning" icon="el-icon-edit-outline" v-if="stepsActive==3||stepsActive==5" @click="noAuditTip">审核退回</el-button>
            </div>
            
        </div>
       
        <el-tabs type="border-card" @tab-click="changeTab">
            <el-tab-pane label="案件信息">
                <div :style="height+';overflow-y: scroll;'">
                    <div class="section">
                        <div class="title">
                            基本信息
                        </div>
                        <div class="item">
                            <div class="label">
                                赔案号
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cClmNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>

                        <!-- <div class="item">
                            <div class="label">
                                调查任务
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cDoubtId" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                调度人
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.dispatcher" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div> -->
                        
                        <div class="item">
                            <div class="label">
                                调查意见
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    <div class="" v-for="(item,index) in cDoubtOpinList" :key="index">
                                        {{item}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="label">
                                <span class="dot">*</span>
                                公估费用:
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.appraisalFee" placeholder="请输入" size="small" class="citem-input" type="number" disabled></el-input>
                                <!-- @blur="appraisalFeeChange" -->
                            </div>
                        </div>


                        <div class="item">
                            <div class="label">
                                调查时效类型:
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.dcSx" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                是否时效内结案:
                            </div>
                            <div class="value">
                                <el-select v-model="detailData.sxnja" size="small" placeholder="请选择" @change="isBigCaseChange" disabled>
                                    <el-option
                                    v-for="item in isBigList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                调查处理剩余时效:
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.ljgzsx" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>

                        <!-- <div class="item">
                            <div class="label">
                                加派原因
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    {{detailData.jpyq}}
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="section">
                        <div class="title">
                            保险信息
                        </div>
                        <div class="item">
                            <div class="label">
                                保险公司
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.companyName" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                险种类型
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cProdType" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                保障产品
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cProdName" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                保单号
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cPlyNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                投保时间
                            </div>
                            <el-date-picker
                            v-model="detailData.tInsAddTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            disabled
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        <div class="item">
                            <div class="label">
                                被保人
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cInsuredNme" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                被保人证件类型
                            </div>
                            <div class="value">
                                <el-select v-model="detailData.cCertType" size="small" placeholder="请选择"  class="citem-input" disabled>
                                    <el-option
                                    v-for="item in InsuredNoTypeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                    
                        <div class="item">
                            <div class="label">
                                被保人证件号
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cCertNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="title">
                            出险信息
                        </div>
                        <div class="item">
                            <div class="label">
                                出险人
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.personDanger" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            
                            <div class="label">
                                出险时间
                            </div>
                            <div class="value">
                                <el-date-picker
                                v-model="detailData.tAccdntTm"
                                type="datetime"
                                size="small"
                                class="citem-input"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                disabled
                                placeholder="选择日期时间">
                                </el-date-picker>
                            </div>
                        </div>
                    
                        <div class="item">
                            <div class="label">
                                出险地点
                            </div>
                            <div class="value" style="width:590px">
                                <el-input v-model="detailData.cAccdntPlace" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                出险经过
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    {{detailData.cAccdntPro}}
                                </div>
                                <!-- <el-input v-model="detailData.cAccdntPro" placeholder="请输入" size="small" type="textarea" disabled></el-input> -->
                            </div>
                        </div>
                        
                    </div>
                    <div class="section">
                        <div class="title">
                            报案信息
                        </div>
                        <div class="item">
                            <div class="label">
                                报案人
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cRptName" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                报案人电话
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.cRptTell" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                    
                        <div class="item">
                            <div class="label">
                                报案时间
                            </div>
                            <el-date-picker
                            v-model="detailData.tRptTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            disabled
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>

                        
                        
                    </div>


                    <div class="section">
                        <div class="title">
                            调查信息
                        </div>
                        <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5" style="margin:0 10px;width:100%">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddDoubtCourse = true">添加调查节点</el-button>
                                <el-button type="primary" size="mini" @click="downFileAnXinDcTask">下载调查资料</el-button>
                            </div>
                        </div>
                        <div class="section-item" v-for="(mitem,mindex) in doubtCourseList" :key="mindex" style="margin:0 10px;margin-top:10px;width:100%">
                            <div class="stitle" >
                                <div class="stitle-l" >
                                    {{mitem.operator}} <span>({{mitem.operatorMechanism}})</span> 
                                    <div class="stitle-r">
                                        {{mitem.executeAction==0?'待接收':''}} 
                                        {{mitem.executeAction==10?'待派工':''}} 
                                        {{mitem.executeAction==20?'调查中':''}} 
                                        {{mitem.executeAction==25?'待审核':''}} 
                                        {{mitem.executeAction==30?'已提交':''}} 
                                        {{mitem.executeAction==40?'任务退回':''}} 
                                        {{mitem.executeAction==50?'完成':''}} 
                                    </div>
                                    <i class="el-icon-folder-opened" v-if="mitem.isOpen" @click="changeIsOpen(mindex)"></i>
                                    <i class="el-icon-folder" v-else @click="changeIsOpen(mindex)"></i>
                                </div>
                            </div>
                            <el-table
                                :data="mitem.doubtCourses"
                                border
                                :header-cell-style="tableHeaderColor"
                                style="width:100%"
                                v-if="mitem.isOpen"
                                >
                                <el-table-column
                                type="index"
                                label="序号"
                                width="60"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="dcTaskSubJect"
                                label="调查节点"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="tCourTm"
                                label="调查时间"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourAddr"
                                label="调查省级市"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourPlace"
                                label="调查地点"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPlace==1">医院</span>
                                    <span v-if="scope.row.cCourPlace==2">事故地</span>
                                    <span v-if="scope.row.cCourPlace==3">常住地</span>
                                    <span v-if="scope.row.cCourPlace==4">住宅</span>
                                    <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                    <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourPro"
                                label="调查项目"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPro==1">正面调查</span>
                                    <span v-if="scope.row.cCourPro==2">基础调查</span>
                                    <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                    <span v-if="scope.row.cCourPro==4">事故查勘</span>
                                </template>
                                </el-table-column>
                            
                                <el-table-column
                                prop="cCourMode"
                                label="案件类型"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourMode=='1'">全案</span>
                                    <span v-if="scope.row.cCourMode=='2'">单点</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourOperNme"
                                label="被调查人姓名"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourRela"
                                label="被调查人与被保人关系"
                                align="center"
                                width="180px"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                    <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                    <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                    <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                    <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                    <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                    <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                    <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                    <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                    <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                    <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                    <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                    <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                    <span v-if="scope.row.cCourRela=='601016'">未知</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cProcess"
                                label="调查过程"
                                align="center"
                                width="150px"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                                </template>
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="180px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div class="section-item" style="margin:0 10px;margin-top:10px;width:100%">
                            <div class="stitle" >
                                <div>
                                    其他
                                    <i class="el-icon-folder-opened" v-if="isOtherDoubtCourseListOpen" @click="isOtherDoubtCourseListOpen = false"></i>
                                    <i class="el-icon-folder" v-else @click="isOtherDoubtCourseListOpen = true"></i>
                                </div>
                            </div>
                            <el-table
                                :data="otherDoubtCourseList"
                                border
                                :header-cell-style="tableHeaderColor"
                                style="width:100%"
                                v-if="isOtherDoubtCourseListOpen"
                                >
                                <el-table-column
                                type="index"
                                label="序号"
                                width="60"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="dcTaskSubJect"
                                label="调查节点"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="tCourTm"
                                label="调查时间"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourAddr"
                                label="调查省级市"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourPlace"
                                label="调查地点"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPlace==1">医院</span>
                                    <span v-if="scope.row.cCourPlace==2">事故地</span>
                                    <span v-if="scope.row.cCourPlace==3">常住地</span>
                                    <span v-if="scope.row.cCourPlace==4">住宅</span>
                                    <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                    <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourPro"
                                label="调查项目"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPro==1">正面调查</span>
                                    <span v-if="scope.row.cCourPro==2">基础调查</span>
                                    <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                    <span v-if="scope.row.cCourPro==4">事故查勘</span>
                                </template>
                                </el-table-column>
                            
                                <el-table-column
                                prop="cCourMode"
                                label="案件类型"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourMode=='1'">全案</span>
                                    <span v-if="scope.row.cCourMode=='2'">单点</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourOperNme"
                                label="被调查人姓名"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourRela"
                                label="被调查人与被保人关系"
                                align="center"
                                width="180px"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                    <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                    <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                    <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                    <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                    <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                    <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                    <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                    <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                    <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                    <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                    <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                    <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                    <span v-if="scope.row.cCourRela=='601016'">未知</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cProcess"
                                label="调查过程"
                                align="center"
                                width="150px"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                                </template>
                                </el-table-column>
                                

                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="180px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <!-- <div class="section-item" style="margin:0 10px;margin-top:10px;width:100%">
                            <div class="stitle">
                                <div class="stitle-l">
                                    报告
                                </div>
                                <div class="stitle-audit">
                                    <el-button type="text" icon="el-icon-download" size="small" @click="querayDcTaskOperatorByAnXinDcTaskId" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">生成报告</el-button>
                                </div>
                            </div>
                            <div class="materiallist">
                                <div class="material" v-if="report.path">
                                    <img src="../../../assets/images/icon13.png" alt="" :fit="cover" @click="download(report.path,report.name)">
                                    <div class="filename">{{report.fileName}}</div>
                                </div>
                            </div>
                        </div> -->
                    </div>

                    <div class="section">
                        <div class="title">
                            调查报告
                        </div>
                        <div class="section-item" style="margin:0 10px;padding-top:10px;width:100%">
                            
                            <div class="materiallist">
                                <div class="material" v-if="report.path">
                                    <img src="../../../assets/images/icon13.png" alt="" fit="cover" @click="download(report.path,report.name)">
                                    <div class="filename">{{report.fileName}}</div>
                                    <img src="../../../assets/images/icon08.png" class="close" @click="deleteDoubTaskMaterialTip(report.id)" alt="" v-if="(stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5||isAdmin)&&stepsActive<7">
                                </div>
                                <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="uploadPDF"
                                v-if="(stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5||isAdmin)&&stepsActive<7"
                                >
                                    <el-button type="success" icon="el-icon-upload" size="small" style="margin:0 10px">上传报告</el-button>
                                </el-upload>
                                <el-button type="primary" icon="el-icon-download" size="small" @click="querayDcTaskOperatorByAnXinDcTaskId" v-if="(stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5||isAdmin)&&stepsActive<7">生成报告</el-button>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="title">
                            调查结论
                        </div>
                        <div class="item">
                            <div class="label">
                                调查结论
                            </div>
                            <div class="value">
                                <el-select v-model="detailData.cConclusion" size="small" placeholder="请选择">
                                    <el-option
                                    v-for="item in cConclusionList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                调查意见
                            </div>
                            <div class="value" style="width:890px">
                                <el-input v-model="detailData.cConcRst" placeholder="" size="small" type="textarea" :rows="8"></el-input>
                                
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                派工时间
                            </div>
                            <el-date-picker
                            v-model="detailData.dcTaskPgTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        <div class="item" v-if="detailData.cConclusion=='3'">
                            <div class="label">
                                拒赔原因
                            </div>
                            <div class="value" style="width:890px">
                                <el-input v-model="detailData.cRefuseRsn" placeholder="" size="small" type="textarea" ></el-input>

                            
                            </div>
                        </div>
                        <div class="item" v-if="detailData.cConclusion=='3'">
                            <div class="label">
                                拒赔金额
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                            </div>
                        </div>
                        <div class="item" v-if="detailData.cConclusion=='2'">
                            <div class="label">
                                减损金额
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.nDeroAmt" placeholder="请输入" size="small" type="number"></el-input>
                            </div>
                        </div>
                        <div class="item" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5"> 
                            <el-button type="primary" icon="el-icon-edit" @click="updateCccnn">确认修改</el-button>
                        </div>

                    </div>
                    <div class="section">
                        <div class="title">
                            保司审核信息
                        </div>
                        <div class="item">
                            <div class="label">
                                保司审核状态
                            </div>
                            <div class="value">
                                <el-select v-model="detailData.auditResult" size="small" placeholder="请选择" disabled>
                                    <el-option
                                    v-for="item in auditResultList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="label">
                                审核备注
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    {{detailData.backReason}}
                                </div>
                                <!-- <el-input v-model="detailData.backReason" placeholder="请输入" size="small" type="textarea"></el-input> -->
                            </div>
                        </div>
                    </div>
                    
                    <div class="section">
                        <div class="title">
                            结案信息
                        </div>
                        <div class="item">
                            <div class="label">
                                赔付结论
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    {{detailData.claimResultStr}}
                                </div>
                                <!-- <el-input v-model="detailData.claimResultStr" placeholder="请输入" size="small" type="textarea"></el-input> -->
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                实际赔付金额
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.actualAmount" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                减损金额
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.derogationAmount" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                约定赔付金额
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.agreedAmount" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                
               
            </el-tab-pane>
            <el-tab-pane label="派工信息">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addSurveyDataDialog=true">添加调查信息</el-button>
                            </div>
                        </div>
                        <el-table
                            :data="surveyData"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width:100%"
                            >
                            <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                            align="center"
                            >
                            </el-table-column>
                        
                            <el-table-column
                            prop="cSvyNeed"
                            label="调查需求"
                            align="center"
                            >
                            </el-table-column>
                            
                            <el-table-column
                            prop="tHopeEndTm"
                            label="期望完成时间"
                            align="center"
                            width="200">
                            <template slot-scope="scope">
                                <span style="color:red">{{scope.row.tHopeEndTm}}</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cSvyType"
                            label="疑似类型"
                            align="center"
                            width="150">
                            </el-table-column>
                            <el-table-column
                            prop="cSvyMode"
                            label="案件类型"
                            align="center"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="cSvyPlace"
                            label="调查地点"
                            align="center"
                            width="180"
                            >
                            </el-table-column>
                            
                            <el-table-column
                            prop="cSvyAddr"
                            label="调查地址"
                            align="center"
                            width="240"
                            >
                            </el-table-column>
                            <!-- <el-table-column
                            prop="creationTime"
                            label="创建时间"
                            align="center"
                            width="180"
                            >
                            </el-table-column> -->
                            <el-table-column
                            fixed="right"
                            label="操作"
                            width="180px"
                            align="center"
                            v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit" size="mini" @click="surveyDataItemDialogOpen(scope.row,scope.$index)">编辑</el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="派工资料">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        <div class="materiallist">
                            <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path"
                                v-else
                                @click="showImgM(item.path,surveyInfo)"
                                :fit="cover"></el-image>
                                <img src="../../../assets/images/icon08.png" class="close" @click="clearSurveyInfoMaterial(index)" alt="" >
                                <div class="filename">{{item.name}}</div>
                            </div>

                            <div v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">
                                <el-upload
                                    :action="uploadUrl"
                                    multiple
                                    :show-file-list="false"
                                    :http-request="addSurveyInfo"
                                    >
                                    <el-button type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
                                </el-upload>
                            </div>
                        </div>
                        <div class="btns" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">
                            <el-button type="primary" icon="el-icon-edit" @click="editSurveyInfo" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">确认修改</el-button>
                            <el-button type="primary" icon="el-icon-download" @click="downloadSurveyInfo">下载派工资料</el-button>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="作业机构">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="assignJobAgencies()">指派作业机构</el-button>
                            </div>
                        </div>
                        <el-table
                            :data="jobAgenciesData"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column
                            type="index"
                            width="80"
                            label="序号"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operatorMechanism"
                            label="机构名称"
                            align="center"
                            >
                            </el-table-column>
                            
                            <el-table-column
                            prop="executeAction"
                            label="任务状态"
                            align="center"
                            >
                            <template slot-scope="scope">
                                {{scope.row.executeAction==0?"新任务":""}}
                                {{scope.row.executeAction==10?"任务待派调查员":""}}
                                {{scope.row.executeAction==20?"任务作业中":""}}
                                {{scope.row.executeAction==25?"任务待机构审核":""}}
                                {{scope.row.executeAction==26?"异地作业审核":""}}
                                {{scope.row.executeAction==30?"任务待总部审核":""}}
                                {{scope.row.executeAction==40?"任务退回":""}}
                                {{scope.row.executeAction==50?"任务完成":""}}
                                {{scope.row.executeAction==70?"取消委托":""}}

                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="taskFee"
                            label="公估费用"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="rewardFee"
                            label="奖励费用"
                            align="center"
                            >
                            </el-table-column>
                            
                            <el-table-column
                            prop="isZhuPaiJiGou"
                            label="是否主查机构"
                            align="center"
                            >
                            <template slot-scope="scope">
                                {{scope.row.isZhuPaiJiGou?"是":"否"}}
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="dcyq"
                            label="调查要求"
                            align="center"
                            width="400px"
                            >
                            <template slot-scope="scope">
                                {{scope.row.dcyq?scope.row.dcyq:"无"}}
                            </template>
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            label="操作"
                            width="280px"
                            align="center"
                            v-if="isNoaAgrent!='1'"
                            >
                            <template slot-scope="scope">
                                <div v-if="scope.row.executeAction==26">
                                    <el-button type="text" icon="el-icon-edit" size="mini" @click="updateExecuteAction(scope.row)">同意</el-button>
                                    <el-button type="text" icon="el-icon-edit" size="mini" @click="noAgree(scope.row)">不同意</el-button>
                                </div>
                                <div v-else>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="cancelAssign(scope.row)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5||isAdmin">取消指派</el-button>
                                    <el-button type="text" icon="el-icon-edit" size="mini" @click="setZhuPaiMechanismTip(scope.row)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5||isAdmin">设为主派</el-button>
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="JgDetail(scope.row)">查看人员</el-button>
                                    <el-button type="text" icon="el-icon-edit" size="mini" @click="assignPersonTip(scope.row)">指派人员</el-button>
                                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTaskFeeTip(scope.row)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5||isAdmin">编辑</el-button>
                                </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            
           
            <el-tab-pane label="案件日志">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        
                        <el-table
                            :data="logList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column
                            type="index"
                            width="80"
                            label="序号"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operator"
                            label="操作人"
                            align="center"
                            width="250px"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="content"
                            label="操作内容"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="creationTime"
                            label="操作时间"
                            align="center"
                            width="250px"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="财务日志">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        
                        <el-table
                            :data="financeLogList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column
                            type="index"
                            width="80"
                            label="序号"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operator"
                            label="操作人"
                            align="center"
                            width="250px"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="content"
                            label="操作内容"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operatorTime"
                            label="操作时间"
                            align="center"
                            width="250px"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>

        </el-tabs>
        
        

        

       
        
        <el-dialog :close-on-click-modal="false" :visible.sync="surveyDataItemDialog" title="调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        
                        <el-autocomplete
                            class="inline-input"
                            v-model="surveyDataItem.cSvyNeed"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.label }}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.tHopeEndTm"
                        type="date"
                        size="small"
                        class="citem-input"
                        format="yyyy-MM-dd"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        疑案类型
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyTypeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in cSvyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                            <el-option
                            v-for="item in cSvyModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyPlaceCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyPlace">
                            <el-option
                            v-for="item in cSvyPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
                <!-- <div class="item">
                    <div class="label">
                        调查内容
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="assignData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div> -->
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="updateAnXinDcTask">确认编辑</el-button>
                </div>
               
            </div>
            
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="800px">
            <div class="condition">
                <div class="item">
                    <div class="label">机构名称:</div>
                    <el-input v-model="conditionDataMechanism.Name" size="small" placeholder="请输入机构名称"></el-input>
                </div>
                <el-button type="primary" size="small" @click="selectDataMechanism()">查询</el-button>
                <el-button type="" size="small" @click="resetMechanism()">重置</el-button>
            </div>
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionMechanismChange"
            style="width:100%"
            height="400px"
            >
            <!-- <el-table-column
            type="selection"
            align="center"
            width="55">
            </el-table-column> -->
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" @click="selectMechanism(scope.row)" icon="el-icon-edit-outline">确 定</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeMechanism"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCountMechanism"
                    :current-page="conditionDataMechanism.page"
                    :page-size="conditionDataMechanism.pageSize">
                </el-pagination>
            </div>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAssignJobAgencies" title="指派机构" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        机构：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.operatorMechanism" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查要求：
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="assignJobAgenciesData.dcyq" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        公估费用
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.taskFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <el-checkbox v-model="assignJobAgenciesData.isZhuPaiJiGou">主案机构</el-checkbox>
                </div>

                <div class="dialog-btn">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="affirmMechanism">确定</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isPersonTaskDialog" :title="personTaskTitle" width="1200px">
            <div class="table">
                <el-table
                    :data="personTaskList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    
                    <el-table-column
                    prop="cClmNo"
                    label="赔案号"
                    align="center"
                    width="250px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="cPlyNo"
                    label="保单号"
                    align="center"
                    width="250px"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="operator"
                    label="调查员"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="executeAction"
                    label="任务状态"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <!-- {{scope.row.executeAction==0?"待接收":""}}
                        {{scope.row.executeAction==10?"待派工":""}}
                        {{scope.row.executeAction==20?"调查中":""}}
                        {{scope.row.executeAction==25?"待审核":""}}
                        {{scope.row.executeAction==30?"已提交":""}}
                        {{scope.row.executeAction==40?"任务退回":""}}
                        {{scope.row.executeAction==50?"完成":""}} -->

                        {{scope.row.executeAction==0?"新任务":""}}
                        {{scope.row.executeAction==10?"任务待派调查员":""}}
                        {{scope.row.executeAction==20?"任务作业中":""}}
                        {{scope.row.executeAction==25?"任务待机构审核":""}}
                        {{scope.row.executeAction==26?"多地作业审核":""}}
                        {{scope.row.executeAction==30?"任务待总部审核":""}}
                        {{scope.row.executeAction==40?"任务退回":""}}
                        {{scope.row.executeAction==50?"任务完成":""}}
                        {{scope.row.executeAction==70?"取消委托":""}}

                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="auditStatus"
                    label="审核状态"
                    align="center"
                    width="150px"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.auditStatus==10">待机构审核</span>
                        <span v-else-if="scope.row.auditStatus==20">审核不通过</span>
                        <span v-else-if="scope.row.auditStatus==30">机构审核通过</span>
                        <span v-else-if="scope.row.auditStatus==40">待总部审核</span>
                        <span v-else-if="scope.row.auditStatus==50">总部审核不通过</span>
                        <span v-else-if="scope.row.auditStatus==60">总部审核通过</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="isZhuPai"
                    label="是否主派"
                    align="center"
                    >
                    <template slot-scope="scope">
                        {{scope.row.isZhuPai?"是":"否"}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="240px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="personDetail(scope.row)">查看详情</el-button>
                        <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cancelAssignPerson(scope.row)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">取消指派</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleCurrentChangeUser"
                        background
                        layout="prev, pager, next, total"
                        :total="userTotalCount"
                        :current-page="userConditionData.page"
                        :page-size="userConditionData.pageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isTaskReason" title="提交调查任务到安心" width="800px">
            <div class="item">
                <div class="label">
                    调查意见
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="detailData.cConcRst" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    调查结论
                </div>
                <div class="value">
                    <el-select v-model="detailData.cConclusion" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in cConclusionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="item" v-if="detailData.cConclusion=='3'">
                <div class="label">
                    拒赔金额
                </div>
                <div class="value">
                    <el-input v-model="detailData.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                </div>
            </div>
            <div class="item" v-if="detailData.cConclusion=='2'">
                <div class="label">
                    减损金额
                </div>
                <div class="value">
                    <el-input v-model="detailData.nDeroAmt" placeholder="请输入" size="small" type="number"></el-input>
                </div>
            </div>
            <div class="item" v-if="detailData.cConclusion=='3'">
                <div class="label">
                    拒赔原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="detailData.cRefuseRsn" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
            
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="doubtTaskComplete()">确认</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isNoAudit" title="拒绝调查" width="800px">
           
            <div class="item">
                <div class="label">
                    拒绝调查原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="reason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="backForUpdate()">确认</el-button>
            </div>
        </el-dialog>
        

        

        <el-dialog :close-on-click-modal="false" :visible.sync="isPersonInfoDialog" title="查看调查员资料" width="1500px" top="20px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div style="margin:0 10px;width:100%">
                    <!-- <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addAllMaterialInfoTip">添加资调查过程</el-button>
                        </div>
                    </div> -->
                    <el-table
                        :data="personDoubtCourseList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="dcTaskSubJect"
                        label="调查节点"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        prop="cCourAddr"
                        label="调查地址"
                        align="center"
                        >
                        </el-table-column> -->
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column> -->
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="mini" @click="editCCour(scope.row)" >编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourPerson(scope.row)" >删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="section">
                <div class="title">
                    调查资料
                </div>
                <div style="margin:0 10px;width:100%">
                    <!-- <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addOtherMaterialDialog">添加资料</el-button>
                        </div>
                    </div> -->
                    <div class="section-item" v-for="(mitem,mindex) in personMaterialList" :key="mindex">
                        <div class="stitle">{{mitem[0].name}}</div>
                        <div class="materiallist">
                            <div class="material" v-for="(item,index) in mitem" :key="index">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path+'?x-oss-process=image/resize,w_200'"
                                v-else
                                @click="showImg(item.path,mitem)"
                                :fit="cover"></el-image>
                                <img src="../../../assets/images/icon08.png" class="close" @click="clearOtherMaterial(item)" alt="" >

                                <div class="filename">{{item.fileName}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns" v-if="(stepsActive==2||detailData.executeAction==25)&&!isNoHandle">
                <el-button type="primary" icon="el-icon-edit" @click="examineTask(20)">审核不通过</el-button>
                <el-button type="success" icon="el-icon-edit" @click="examineTask(60)">审核通过</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isNoPersonAudit" title="审核不通过" width="800px">
           
            <div class="item">
                <div class="label">
                    不通过原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="personTaskReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="examineTaskApi(20)">确认</el-button>
            </div>
        </el-dialog>


        <el-dialog
            title="调查过程"
            :visible.sync="cProcessDetailDialog"
            width="600px"
            :modal="false"
            v-dialogDrag
            >
            <el-input
            placeholder="请输入内容"
            v-model="cProcess"
            type="textarea"
            :rows="20"
            >
            </el-input>
        </el-dialog>
        

        <el-dialog :close-on-click-modal="false" :visible.sync="isAuditBackDialog" title="审核退回" width="800px">
           
            <div class="item">
                <div class="label">
                    审核退回原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="taskReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="auditBack">确认</el-button>
            </div>
        </el-dialog>

        <!-- 案件审核不通过 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="isNoAuditDialog" title="审核退回" width="800px">
           
            <div class="item">
                <div class="label">
                    审核退回原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="returnReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="noAuditApi">确认</el-button>
            </div>
        </el-dialog>

        
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />

        <el-dialog :close-on-click-modal="false" :visible.sync="isAssignPerson" title="指派人员" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        人员：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignPersonData.operator" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="selectOperator()">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查要求：
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="assignPersonData.dcyq" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>

                <!-- <div class="item" v-if="zpjg">
                    <el-checkbox v-model="assignPersonData.isZhuPai">主案人员</el-checkbox>
                </div> -->

                <div class="dialog-btn">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="affirmPerson">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="userDialog" title="选择人员" width="600px">
            <div class="table">
                <el-table
                    :data="userList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    
                    <el-table-column
                    prop="name"
                    label="用户名称"
                    align="center"
                    >
                    </el-table-column>
                    
                    <el-table-column
                    prop="roleNames"
                    label="关联角色"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" icon="el-icon-circle-check" @click="selectPerson(scope.row)">确认指派</el-button>
                    </template>
                    </el-table-column>
                </el-table>
               
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="addSurveyDataDialog" title="新增调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        <el-autocomplete
                            class="inline-input"
                            v-model="addSurveyData.cSvyNeed"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.label }}</div>
                            </template>
                        </el-autocomplete>
                        <!-- <el-select v-model="addSurveyData.cSvyNeedCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyNeed" style="width:100%">
                            <el-option
                            v-for="item in cSvyNeedList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select> -->
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addSurveyData.tHopeEndTm"
                        type="date"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        疑案类型
                    </div>
                    <div class="value">
                        <el-select v-model="addSurveyData.cSvyTypeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in cSvyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addSurveyData.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                            <el-option
                            v-for="item in cSvyModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        
                        <el-select v-model="addSurveyData.cSvyPlaceCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyPlace">
                            <el-option
                            v-for="item in cSvyPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addSurveyData.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
               <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="addSurveyDataFun">确认新增</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDoubtCourse" title="添加调查节点" width="800px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div class="item">
                    <div class="label">
                        调查节点
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.dcTaskSubJect" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addDoubtCourse.tCourTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        调查省级市
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="selectedOptions"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPlace" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查项目
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPro" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourProList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourMode" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in CCourModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人姓名
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourOperNme" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人与被保人关系
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourRela" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourRelaList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查过程
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="addDoubtCourse.cProcess" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
               
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-zoom-in" @click="addDoubtCourseF">确认</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddOtherMaterialDialog" title="添加资料" width="800px">
            <div class="section">
                
                <div class="item">
                    <div class="label">
                        调查人员
                    </div>
                    <div class="value">
                        <el-select v-model="allOperator" size="small" placeholder="请选择" class="citem-input" @change="changeAddDoubtCourseOperator">
                            <el-option
                            v-for="item in personTaskList"
                            :key="item.operatorId"
                            :label="item.operator"
                            :value="item.operatorId">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                
               <div class="item">
                    <div class="label">
                        资料名称
                    </div>
                    <div class="value">
                        <el-input v-model="addCaseMaterial.name" size="small" placeholder="请输入" style="width:300px"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单证资料
                    </div>
                    <div class="value" style="width:300px">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addOtherMaterial"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small" :loading="finishNum!=allNum?true:false">上传资料</el-button>
                        </el-upload>
                        <span style="margin-left:10px">
                            完成度：{{finishNum}} / {{allNum}} {{finishNum!=allNum?'请稍等':''}}
                        </span>
                    </div>
                </div>
                <div class="materiallist">
                    <div class="material" v-for="(item,index) in addOtherMaterialList" :key="index">
                        <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                        <el-image
                        style="width: 120px; height: 120px"
                        :src="item.path"
                        v-else
                        @click="download(item.path,item.name)"
                        :fit="cover"></el-image>
                        <div class="filename">{{item.fileName}}</div>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="addOtherMaterialApi">确认</el-button>
                </div>
            </div>
           
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isEditMaterialNameDialog" title="修改资料分类名称" width="800px">
            <div class="item">
                <div class="label">
                    资料分类名称：
                </div>
                <div class="value" style="width:500px">
                    <el-input v-model="editMaterialNameData.name" placeholder="请输入" size="small"></el-input>
                </div>
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="editMaterialNameApi">确认</el-button>
            </div>
        </el-dialog>
        

         <el-dialog :close-on-click-modal="false" :visible.sync="isAddMaterialItemDialog" title="添加资料分类" width="800px">
            <div class="section">
               <div class="item">
                    <div class="label">
                        资料名称
                    </div>
                    <div class="value">
                        <el-input v-model="addMaterialItemDataName" size="small" placeholder="请输入" style="width:300px"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单证资料
                    </div>
                    <div class="value" style="width:300px">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addMaterialItem"
                            >

                            <el-button icon="el-icon-upload2" type="primary" size="small" :loading="finishNum!=allNum?true:false">上传资料</el-button>
                        </el-upload>
                        <span style="margin-left:10px">
                            完成度：{{finishNum}} / {{allNum}} {{finishNum!=allNum?'请稍等':''}}
                        </span>
                    </div>
                </div>
                <div class="materiallist">
                    <div class="material" v-for="(item,index) in addMaterialItemData.materialItem" :key="index">
                        <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                        <el-image
                        style="width: 120px; height: 120px"
                        :src="item.path"
                        v-else
                        @click="download(item.path,item.name)"
                        :fit="cover"></el-image>
                        <div class="filename">{{item.fileName}}</div>
                        <img src="../../../assets/images/icon08.png" class="close" @click="clearAddMaterial(index)" alt="" >
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="addMaterialItemApi">确认</el-button>
                </div>
            </div>
           
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditTaskFeeTip" title="编辑" width="800px">
            <div class="section">
               <div class="item">
                    <div class="label">
                        公估费用
                    </div>
                    <div class="value">
                        <el-input v-model="editTaskFeeData.taskFee" size="small" placeholder="请输入" style="width:300px" type="number"></el-input>
                    </div>
                </div>
                <div class="item" v-if="editTaskFeeData.taskFee=='0'">
                    <div class="label">
                        公估费用为0原因
                    </div>
                    <div class="value">
                        <el-select v-model="editTaskFeeData.taskFeeReason" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in taskFeeReasonList"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        奖励费用
                    </div>
                    <div class="value">
                        <el-input v-model="editTaskFeeData.rewardFee" size="small" placeholder="请输入" style="width:300px" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        是否主派机构
                    </div>
                    <div class="value">
                        <el-select v-model="editTaskFeeData.isZhuPaiJiGou" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in isZhuPaiJiGouList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" style="width:100%">
                    <div class="label">
                        调查要求
                    </div>
                    <div class="value" style="width:588px">
                        <el-input v-model="editTaskFeeData.dcyq" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
               
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="editTaskFee">确认</el-button>
                </div>
            </div>
           
        </el-dialog>
        
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isApplyDispatchTip" title="申请加派/延期" width="1200px">
                <div class="section">
                    <div class="title">
                        调查信息
                    </div>
                    <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5" style="margin:0 10px;width:100%">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddDoubtCourse = true">添加调查节点</el-button>
                        </div>
                    </div>
                    <div class="section-item" v-for="(mitem,mindex) in doubtCourseList" :key="mindex" style="margin:0 10px;margin-top:10px;width:100%">
                        <div class="stitle" >
                            <div>
                                {{mitem.operator}} 
                                <i class="el-icon-folder-opened" v-if="mitem.isOpen" @click="changeIsOpen(mindex)"></i>
                                <i class="el-icon-folder" v-else @click="changeIsOpen(mindex)"></i>

                                
                            </div>
                            <div class="stitle-r">
                                {{mitem.executeAction==0?'待接收':''}} 
                                {{mitem.executeAction==10?'待派工':''}} 
                                {{mitem.executeAction==20?'调查中':''}} 
                                {{mitem.executeAction==25?'待审核':''}} 
                                {{mitem.executeAction==30?'已提交':''}} 
                                {{mitem.executeAction==40?'任务退回':''}} 
                                {{mitem.executeAction==50?'完成':''}} 
                            </div>
                            

                        </div>
                        <el-table
                            :data="mitem.doubtCourses"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width:100%"
                            v-if="mitem.isOpen"
                            >
                            <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="dcTaskSubJect"
                            label="调查节点"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="tCourTm"
                            label="调查时间"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourAddr"
                            label="调查省级市"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourPlace"
                            label="调查地点"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourPlace==1">医院</span>
                                <span v-if="scope.row.cCourPlace==2">事故地</span>
                                <span v-if="scope.row.cCourPlace==3">常住地</span>
                                <span v-if="scope.row.cCourPlace==4">住宅</span>
                                <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cCourPro"
                            label="调查项目"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourPro==1">正面调查</span>
                                <span v-if="scope.row.cCourPro==2">基础调查</span>
                                <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                <span v-if="scope.row.cCourPro==4">事故查勘</span>
                            </template>
                            </el-table-column>
                        
                            <el-table-column
                            prop="cCourMode"
                            label="案件类型"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourMode=='1'">全案</span>
                                <span v-if="scope.row.cCourMode=='2'">单点</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cCourOperNme"
                            label="被调查人姓名"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourRela"
                            label="被调查人与被保人关系"
                            align="center"
                            width="180px"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                <span v-if="scope.row.cCourRela=='601016'">未知</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cProcess"
                            label="调查过程"
                            align="center"
                            width="150px"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                            </template>
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                label="操作"
                                width="180px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="section-item" style="margin:0 10px;margin-top:10px;width:100%">
                        <div class="stitle" >
                            <div>
                                其他
                                <i class="el-icon-folder-opened" v-if="isOtherDoubtCourseListOpen" @click="isOtherDoubtCourseListOpen = false"></i>
                                <i class="el-icon-folder" v-else @click="isOtherDoubtCourseListOpen = true"></i>
                            </div>
                        </div>
                        <el-table
                            :data="otherDoubtCourseList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width:100%"
                            v-if="isOtherDoubtCourseListOpen"
                            >
                            <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="dcTaskSubJect"
                            label="调查节点"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="tCourTm"
                            label="调查时间"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourAddr"
                            label="调查省级市"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourPlace"
                            label="调查地点"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourPlace==1">医院</span>
                                <span v-if="scope.row.cCourPlace==2">事故地</span>
                                <span v-if="scope.row.cCourPlace==3">常住地</span>
                                <span v-if="scope.row.cCourPlace==4">住宅</span>
                                <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cCourPro"
                            label="调查项目"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourPro==1">正面调查</span>
                                <span v-if="scope.row.cCourPro==2">基础调查</span>
                                <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                <span v-if="scope.row.cCourPro==4">事故查勘</span>
                            </template>
                            </el-table-column>
                        
                            <el-table-column
                            prop="cCourMode"
                            label="案件类型"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourMode=='1'">全案</span>
                                <span v-if="scope.row.cCourMode=='2'">单点</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cCourOperNme"
                            label="被调查人姓名"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourRela"
                            label="被调查人与被保人关系"
                            align="center"
                            width="180px"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                <span v-if="scope.row.cCourRela=='601016'">未知</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cProcess"
                            label="调查过程"
                            align="center"
                            width="150px"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                            </template>
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                label="操作"
                                width="180px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="section">
                    <div class="title">
                        调查结论
                    </div>
                    <div class="item">
                        <div class="label">
                            调查结论
                        </div>
                        <div class="value">
                            <el-select v-model="detailData.cConclusion" size="small" placeholder="请选择">
                                <el-option
                                v-for="item in cConclusionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查意见
                        </div>
                        <div class="value" style="width:890px">
                            <el-input v-model="detailData.cConcRst" placeholder="" size="small" type="textarea" :rows="8"></el-input>
                            
                        </div>
                    </div>
                    <div class="item" v-if="detailData.cConclusion=='3'">
                        <div class="label">
                            拒赔原因
                        </div>
                        <div class="value" style="width:890px">
                            <el-input v-model="detailData.cRefuseRsn" placeholder="" size="small" type="textarea" ></el-input>

                           
                        </div>
                    </div>
                    <div class="item" v-if="detailData.cConclusion=='3'">
                        <div class="label">
                            拒赔金额
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="detailData.cConclusion=='2'">
                        <div class="label">
                            减损金额
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.nDeroAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5"> 
                        <el-button type="primary" icon="el-icon-edit" @click="updateCccnn">确认修改</el-button>
                    </div>

                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="applyDispatch">确认</el-button>
                </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isProductReportDialog" title="生成报告" width="1400px">
            <div class="product-report">1、请编辑用于生成调查报告的调查节点 <span>(不影响案件的调查节点，仅影响报告生成)</span> </div>
            <el-table
                :data="productReportTaskList"
                border
                :header-cell-style="tableHeaderColor"
                style="width:100%"
                >
                <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="dcTaskSubJect"
                label="调查节点"
                align="center"
                width="200px"
                >
                </el-table-column>
                <el-table-column
                prop="tCourTm"
                label="调查时间"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="cCourAddr"
                label="调查省级市"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="cCourPlace"
                label="调查地点"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourPlace==1">医院</span>
                    <span v-if="scope.row.cCourPlace==2">事故地</span>
                    <span v-if="scope.row.cCourPlace==3">常住地</span>
                    <span v-if="scope.row.cCourPlace==4">住宅</span>
                    <span v-if="scope.row.cCourPlace==5">就诊地</span>
                    <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cCourPro"
                label="调查项目"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourPro==1">正面调查</span>
                    <span v-if="scope.row.cCourPro==2">基础调查</span>
                    <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                    <span v-if="scope.row.cCourPro==4">事故查勘</span>
                </template>
                </el-table-column>
            
                <el-table-column
                prop="cCourMode"
                label="案件类型"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourMode=='1'">全案</span>
                    <span v-if="scope.row.cCourMode=='2'">单点</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cCourOperNme"
                label="被调查人姓名"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="cCourRela"
                label="被调查人与被保人关系"
                align="center"
                width="180px"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourRela=='601002'">子女</span>
                    <span v-if="scope.row.cCourRela=='601003'">父母</span>
                    <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                    <span v-if="scope.row.cCourRela=='601005'">本人</span>
                    <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                    <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                    <span v-if="scope.row.cCourRela=='601008'">其它</span>
                    <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                    <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                    <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                    <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                    <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                    <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                    <span v-if="scope.row.cCourRela=='601016'">未知</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cProcess"
                label="调查过程"
                align="center"
                width="150px"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="180px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="moveUp(scope)">上移</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="moveDown(scope)">下移</el-button>
                        
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCour(scope)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="product-report">2、请选择报告模板</div>
            <div class="product-report-radio">
                <el-radio v-model="productReportType" label="1">固定模板(PDF) - 安心财险</el-radio>
                <el-radio v-model="productReportType" label="3">通用模板(Word) - 通用于健康险、意外险、责任险的案件</el-radio>
                <el-radio v-model="productReportType" label="2">通用模板(Word) - 通用于意外险、责任险的单点代查勘案件</el-radio>
            </div>
            

            <div class="product-report-btn">
                <el-button type="primary" icon="el-icon-download" @click="getPDF">确认生成</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import { batchDownload,batchDownloadList } from "../../../utils/downZip";
import { regionData , CodeToText } from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList,InsuredNoTypeList,CCourModeList ,RefuseRsnList,cSvyNeedList,cSvyModeList,cSvyPlaceList,cSvyTypeList} from "../../../assets/selectList/anxin";
import { parseTimeS,parseTimeD } from "../../../utils/index";
import draggable from 'vuedraggable'
 import "../../../utils/dialog"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'index',
    components:{
        ElImageViewer,
        draggable
    },
    watch: {
        
    },
    data () {
        return {
            fileName:'',
            cSvyNeedList:cSvyNeedList,
            cSvyModeList:cSvyModeList,
            cSvyPlaceList:cSvyPlaceList,
            cSvyTypeList:cSvyTypeList,
            uploadUrl:'',
            RefuseRsnList:RefuseRsnList,
            cCourPlaceList:cCourPlaceList,
            cCourProList:cCourProList,
            cCourRelaList:cCourRelaList,
            InsuredNoTypeList:InsuredNoTypeList,
            CCourModeList:CCourModeList,
            isAssignTask:false,
            detailData:{},
            addDoubtCourse:{},
            addCaseMaterial:{},
            options:regionData,
            selectedOptions:null,
            cConclusionList:[{
                label:'正常赔付',
                value:'1',
            },{
                label:'减损',
                value:'2',
            },{
                label:'拒赔',
                value:'3',
            }],
            auditResultList:[{
                label:'未知',
                value:0,
            },{
                label:'同意',
                value:1,
            },{
                label:'退回',
                value:2,
            }],
            
            jobAgenciesData:[],
            assignData:{},


            surveyData:[],
            surveyInfo:[],
            surveyDataItem:{},
            surveyDataItemDialog:false,

            mechanismList:[],
            isMechanismDialog:false,
            selectMechanismList:[],
            conditionDataMechanism:{
                Name:'',
                page:1,
                pageSize:10,
            },
            totalCountMechanism:0,
            logList:[],
            financeLogList:[],
            stepsActive:0,


            userConditionData:{
                page:1,
                pageSize:10,
            },
            userList:[],
            userDialog:false,
            userTotalCount:0,
            
            isTaskReason:false,
            taskReasonData:{},
            reason:'',
            isNoAudit:false,

            doubtCourseList:[],
            materialList:[],

            allDoubtCourseList:[],
            allMaterialList:[],

            cProcessDetailDialog:false,
            cProcess:'',

            isAuditBackDialog:false,
            auditBackData:{},
            taskReason:'',

            showBigImg:false,
            showBigImgList:[],
            surveyInfo:[],
            imgIndex:0,

            // 指派机构弹框
            isAssignJobAgencies:false,
            assignJobAgenciesData:{},
            
            personTaskList:[],
            isPersonTaskDialog:false,
            personTaskTitle:'',
            personDetailData:{
                doubtCourseList:[],
                doubTaskMaterialItems:[],
            },
            isPersonInfoDialog:false,
            personDoubtCourseList:[],
            personMaterialList:[],

            operatorMechanism:'',
            operatorMechanismId:'',

            isNoPersonAudit:false,
            personTaskReason:'',

            // 查询机构人员
            mechanismId:'',
            

            assignPersonData:{},
            isAssignPerson:false,
            zpjg:false,

            cDoubtOpinList:[],

            // 审核退回弹框
            isNoAuditDialog:false,
            returnReason:'',

            // 新增派工
            addSurveyDataDialog:false,
            addSurveyData:{},

            surveyDataItemDialog:false,
            surveyDataItem:{},
            surveyDataIndex:0,

            

            // 人员任务id
            personId:'',

            otherJgList:[],
            otherMaterialList:[],
            otherDoubtCourseList:[],
            addOtherMaterialList:[],
            isAddDoubtCourse:false,
            // 机构id
            jgRwId:'',
            personTaskList:[],
            allOperatorId:'',
            allOperator:'',
            allDoubtTaskId:'',
            isAddAllZlDialog:false,
            isAddOtherMaterialDialog:false,
            materialIndex:0,

            allNum:0,
            finishNum:0,


            operatorList:[],


            // 修改资料分类名称
            isEditMaterialNameDialog:false,
            editMaterialNameData:{
                anXinDcTaskId: "",
                oldName: "",
                name: ""
            },
            // 新增资料分类
            isAddMaterialItemDialog:false,
            addMaterialItemDataName:'',
            addMaterialItemData:{
                anXinDcTaskId: "",
                materialItem: [
                ]
            },
            height:'',
            isEditMaterialSort:false,

            isEditTaskFeeTip:false,
            editTaskFeeData:{
                "doubtTaskId": "",
                "taskFee": 0,
                "rewardFee": 0,
                "taskFeeReason": '',
                "isZhuPaiJiGou": false,

                "dcyq": ''
            },
            isZhuPaiJiGouList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
            isApplyDispatchTip:false,
            applyDispatchData:{
                anXinDcTaskId:'',
                jpyq:'',
            },

            operatorList:[],
            doubtCourseList:[],
            otherDoubtCourseList:[],
            isOtherDoubtCourseListOpen:true,

            report:{},
            productReportType:"1",

        }
    },
    created(){
        

    },
    mounted(){
        this.getHeight();
        // this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();
        this.queryMechanism();
        this.queryAnXinDcTaskByAnXinDcTaskId();
        // this.queryUserByMechanismIds();
        this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
        this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
        this.queryMaterByAnXinDcTaskId();
    },
    methods:{
        async queryMaterByAnXinDcTaskId(){
            let res = await api.queryMaterByAnXinDcTaskId(this.$route.query.id);
            let resData = res.data.data
            this.report = {};
            for(let index in resData){
                if(resData[index].name == '调查报告'){
                    this.report = resData[index];
                }
            }
        },
        // 实时获取宽高
        getHeight(){
            let _this = this;
            _this.height =  'height:'+(document.body.clientHeight-140)+'px';
            window.onresize = function(){
                _this.height =  'height:'+(document.body.clientHeight-140)+'px';
            }
        },
        // 查看上传资料
        async queryDoubtTaskItemMaterialItemByAnXinDcTaskId(){
            let res = await api.queryDoubtTaskItemMaterialItemByAnXinDcTaskId(this.$route.query.id);
            console.log(res);
            this.allMaterialList = res.data.data;
            for(let index in this.allMaterialList){
                this.allMaterialList[index].isOpen = true;
                this.allMaterialList[index].isEditMaterialSort = false;
            }
            
            console.log('this.allMaterialListthis.allMaterialList');
            console.log(this.allMaterialList);
            this.$forceUpdate();
        },
        // 监听是否拖拽
        changeIsEditMaterialSort(mindex){
            this.$forceUpdate();
        },
        // 拖拽接受
        async draggableOnEnd(index){
            console.log(index);
            console.log(this.allMaterialList[index].data);
            for(let i in this.allMaterialList[index].data){
                this.allMaterialList[index].data[i].sort = parseInt(i);
            }
            this.sortDoubTaskMaterialItem(this.allMaterialList[index].data)
        },
        // 排序上传资料
        async sortDoubTaskMaterialItem(list){
            let res = await api.sortDoubTaskMaterialItem(list);
            // if(res.data.code=='200'){
            //     this.$message({
            //         type: 'success',
            //         message: '操作成功!'
            //     });
            // }
        },
        async getAccidentImg(list){
            let ImgList = [];
            console.log(list);
            for(let i in list.data){
                if(list.data[i].fileType=='jpg'||list.data[i].fileType=='png'||list.data[i].fileType=='gif'||list.data[i].fileType=='jpeg'||list.data[i].fileType=='JPG'||list.data[i].fileType=='PNG'||list.data[i].fileType=='GIF'||list.data[i].fileType=='JPEG'){
                    ImgList.push(list.data[i].path);
                }
            }
            let res = await api.imgToPdf({
                imgUrl:ImgList,
                anXinDcTaskId:this.detailData.id,
                name:list.key,
                fileName:list.key+'.pdf',
            });
            if(res.data.code=='200'){
                 this.$message({
                    type: 'success',
                    message: '生成成功!'
                });
                this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();
            }
            
        },
        async uploadPDF(file){
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );


            let res = await api.uploadOther(file.file);
            let path = res;
            let option = {
                fileType:fileType,
                fileName:file.file.name,
                anXinDcTaskId:this.detailData.id,
                path:path,
            };
            let data = await api.uploadDcTaskReport(option);
            if(data.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '上传成功!'
                });
                // this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();
                this.queryMaterByAnXinDcTaskId();

            }
            this.$forceUpdate();
        },
        async uploadImgPDF(file){
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );

            let res = await api.uploadOther(file.file);
            let path = res;
            let option = {
                fileType:fileType,
                fileName:file.file.name,
                name:this.fileName,
                anXinDcTaskId:this.detailData.id,
                path:path,
            };
            let data = await api.uploadDcTaskPdf(option);
            if(data.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '上传成功!'
                });
                this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();

            }
            this.$forceUpdate();
        },
        // 修改资料分类名称
        async editMaterialName(row){
            console.log(row);
            this.isEditMaterialNameDialog = true;
            this.editMaterialNameData.anXinDcTaskId = this.$route.query.id;
            this.editMaterialNameData.oldName = row.key;
            this.editMaterialNameData.name = '';
        },
        // 修改名称
        async editMaterialNameApi(){
            let res = await api.updateDoubTaskMaterialItemName(this.editMaterialNameData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.isEditMaterialNameDialog = false;
                this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();
            }
        },
        // 新增资料分类——上传资料
        async addMaterialItem(file){
            console.log(file.file);
            if(this.addMaterialItemDataName==''){
                this.$message({
                    type: 'warning',
                    message: '名称不能为空!'
                });
                return;
            }
            this.allNum = this.allNum+1;
            let material = {
                fileType:'',
                fileName:'',
                name:this.addMaterialItemDataName,
                path:'',
            };
            material.fileName = file.file.name;
            let fileTypeList = material.fileName.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.finishNum = this.finishNum+1;

            material.path = res;
            console.log(material);

            this.addMaterialItemData.materialItem.push(material);
        },
        // 新增资料分类——确认上传资料
        async addMaterialItemApi(){
            this.addMaterialItemData.anXinDcTaskId = this.detailData.id;
            for(let index in this.addMaterialItemData.materialItem){
                this.addMaterialItemData.materialItem[index].sort = parseInt(index)
            }
            let res = await api.addDoubTaskMaterialItemName(this.addMaterialItemData);
            if(res.data.code == '200'){
                this.isAddMaterialItemDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.addMaterialItemData = {
                    anXinDcTaskId:'',
                    materialItem:[]
                }
                this.finishNum=0;
                this.allNum=0;
                this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();

            }
        },
        clearAddMaterial(index){
            this.addMaterialItemData.materialItem.splice(index,1)
        },

        // 删除资料
        async deleteDoubTaskMaterialTip(id){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubTaskMaterial(id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteDoubTaskMaterial(id){
            let res = await api.deleteDoubTaskMaterial(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.queryMaterByAnXinDcTaskId();
            }
        },
        // 获取调查员信息列表
        // async querayDcTaskOperatorByAnXinDcTaskId(){
        //     let res = await api.querayDcTaskOperatorByAnXinDcTaskId(this.$route.query.id);
        //     if(res.data.code == '200'){
        //         this.operatorList = res.data.data;
        //         this.getPDF();
        //     }
        // },
        async querayDcTaskOperatorByAnXinDcTaskId(){
            let res = await api.querayDcTaskOperatorByAnXinDcTaskId(this.$route.query.id);
            if(res.data.code == '200'){
                this.operatorList = res.data.data;
                this.isProductReportDialog = true;
            }
            this.productReportTaskList = [];
            

            let res1 = await api.queryDoubtTaskItem_CourseByAnXinDcTaskId(this.$route.query.id);
            if(res1.data.code == '200'){
                this.doubtCourseList = res1.data.data;
            }
            for(let i in this.doubtCourseList){
                for(let j in this.doubtCourseList[i].doubtCourses){
                   this.productReportTaskList.push(this.doubtCourseList[i].doubtCourses[j]);
                }
            }
            let res2 = await api.queryByAnXinDcTaskIdExcludeDoubtTaskItem(this.$route.query.id);
            if(res2.data.code == '200'){
                this.otherDoubtCourseList = res2.data.data;
            }
            for(let i in this.otherDoubtCourseList){
                   this.productReportTaskList.push(this.otherDoubtCourseList[i]);
            }
            
        },
        // 获取pdf
        async getPDF(){


            let investigatorList = [];
            for(let index in this.operatorList){
                if(index == 0){
                    investigatorList = this.operatorList[index].operatorName + '\n' + this.operatorList[index].phone;
                }else{
                    investigatorList = investigatorList + '\r' + this.operatorList[index].operatorName + '\n' + this.operatorList[index].phone;
                }
            }

            let nowTime = parseTimeD(new Date());
            let investigation = [];
            
            let fileType = this.productReportType == '1'?'pdf':'doc'
            if(this.productReportType == '1'){
                for(let i in this.productReportTaskList){
                    let cProcess = this.productReportTaskList[i].cProcess.replace(/[\n]/g, "\r\n\n");
                    let num = (investigation.length) + 1;
                    let tCourTm = parseTimeD(this.productReportTaskList[i].tCourTm);
                    investigation.push({
                        title:'\n\n' +num+'、'+this.productReportTaskList[i].dcTaskSubJect+'\r\n\n'+'调查时间：'+tCourTm,
                        bodyStr:'调查过程：\r'+cProcess,
                    })
                }
            }else{
                for(let i in this.productReportTaskList){
                    let cProcess = this.productReportTaskList[i].cProcess.replace(/[\n]/g, "\r\n\n");
                    let num = (investigation.length) + 1;
                    investigation.push({
                        title:'\n\n' +num+'、'+this.productReportTaskList[i].dcTaskSubJect,
                        bodyStr:cProcess,
                    })
                }
            }
            
            
            
            
            // 调查经过
            this.detailData.cAccdntPro = this.detailData.cAccdntPro==null?'':this.detailData.cAccdntPro
            let cAccdntPro = this.detailData.cAccdntPro.replace(/[\r]/g, "");
            cAccdntPro = cAccdntPro.replace(/[\n]/g, "");

            this.detailData.cConcRst = this.detailData.cConcRst==null?'':this.detailData.cConcRst
            let cConcRstList = this.detailData.cConcRst.replace(/[\r]/g, "");
            cConcRstList = cConcRstList.split(/\n/g);

            this.detailData.cDoubtOpin = this.detailData.cDoubtOpin==null?'':this.detailData.cDoubtOpin
            let cDoubtOpinList = this.detailData.cDoubtOpin.replace(/[\r]/g, "");
            cDoubtOpinList = cDoubtOpinList.split(/\n/g);

            let cConcRstProject1 = '';
            let cConcRstProject2 = '';
            let cDoubtOpinProject = '';

            for(let i in cConcRstList){
                cConcRstList[i] = cConcRstList[i].replace(/[\n]/g, "");
                if(i==0){
                    cConcRstProject1 = cConcRstList[i]
                    cConcRstProject2 = '\n\n'+ cConcRstList[i]
                }else{
                    cConcRstProject1 = cConcRstProject1 + '\r\n\n'+ cConcRstList[i]
                    cConcRstProject2 = cConcRstProject2 + '\r\n\n'+ cConcRstList[i]
                }
            }
            for(let i in cDoubtOpinList){
                cDoubtOpinList[i] = cDoubtOpinList[i].replace(/[\n]/g, "");
                if(i==0){
                    cDoubtOpinProject = cDoubtOpinList[i]
                }else{
                    cDoubtOpinProject = cDoubtOpinProject + '\r\n\n'+ cDoubtOpinList[i]
                }
            }
            
            let option = {
                "anXinDcTaskId": this.detailData.id,
                "no": this.operatorList[0].reportNo,
                "principalName": this.detailData.companyName,
                "peoPleName": this.detailData.cInsuredNme,
                "conclusion": cConcRstProject1,
                "reportGenerationTime": nowTime,

               "company": this.detailData.companyName,
                "riskTyep": this.detailData.cProdName,
                "insurePeople": "",
                "policyNo": this.detailData.cPlyNo,
                "reportNo": this.detailData.cClmNo,
                "outRiskTime": parseTimeD(this.detailData.tAccdntTm),
                "outRiskPlace": this.detailData.cAccdntPlace,
                "injuredName": "\n\n"+cAccdntPro,

                // "caseProfile":cAccdntPro,
                "caseProfile":(cAccdntPro&&cAccdntPro.length>0)?cAccdntPro:'',

                "entrustedProject": cDoubtOpinProject,
                "investigation": investigation,
                "conclusionInfo": cConcRstProject2,
                "investigator": investigatorList,//调查员
                
                "template":parseFloat(this.productReportType),
                "dangerName":this.detailData.personDanger,

                "issue": localStorage.getItem('name'),//签发人
                "fileName":"调查报告——"+this.detailData.personDanger+'.'+fileType
            }
            let res = await api.getAccident(option);
            this.$message({
                type: 'success',
                message: '生成成功!'
            });
            this.isProductReportDialog = false;
            this.queryMaterByAnXinDcTaskId();
        },
        // async getPDF(){
        //     let investigatorList = [];
        //     for(let index in this.operatorList){
        //         if(index == 0){
        //             investigatorList = this.operatorList[index].operatorName + '\n' + this.operatorList[index].phone;
        //         }else{
        //             investigatorList = investigatorList + '\r' + this.operatorList[index].operatorName + '\n' + this.operatorList[index].phone;
        //         }
        //     }

        //     let nowTime = parseTimeD(new Date());
        //     let investigation = [];
        //     for(let index in this.allDoubtCourseList){
        //         let cProcess = this.allDoubtCourseList[index].cProcess.replace(/[\n]/g, "\r\n\n");
        //         let num = parseInt(index) + 1;
        //         let tCourTm = parseTimeD(this.allDoubtCourseList[index].tCourTm);
        //         investigation.push({
        //             title:'\n\n' +num+'、'+this.allDoubtCourseList[index].dcTaskSubJect+'\r\n\n'+'调查时间：'+tCourTm,
        //             bodyStr:'调查过程：\r'+cProcess,
        //         })
                
        //     }
            
        //     console.log(nowTime);

        //     // 调查经过
        //     let cAccdntPro = this.detailData.cAccdntPro.replace(/[\r]/g, "");
        //     cAccdntPro = cAccdntPro.replace(/[\n]/g, "");

        //     let cConcRstList = this.detailData.cConcRst.replace(/[\r]/g, "");
        //     cConcRstList = cConcRstList.split(/\n/g);

        //     let cDoubtOpinList = this.detailData.cDoubtOpin.replace(/[\r]/g, "");
        //     cDoubtOpinList = cDoubtOpinList.split(/\n/g);

        //     let cConcRstProject1 = '';
        //     let cConcRstProject2 = '';
        //     let cDoubtOpinProject = '';

        //     for(let i in cConcRstList){
        //         cConcRstList[i] = cConcRstList[i].replace(/[\n]/g, "");
        //         if(i==0){
        //             cConcRstProject1 = cConcRstList[i]
        //             cConcRstProject2 = '\n\n'+ cConcRstList[i]
        //         }else{
        //             cConcRstProject1 = cConcRstProject1 + '\r\n\n'+ cConcRstList[i]
        //             cConcRstProject2 = cConcRstProject2 + '\r\n\n'+ cConcRstList[i]
        //         }
        //     }
        //     for(let i in cDoubtOpinList){
        //         cDoubtOpinList[i] = cDoubtOpinList[i].replace(/[\n]/g, "");
        //         if(i==0){
        //             cDoubtOpinProject = cDoubtOpinList[i]
        //         }else{
        //             cDoubtOpinProject = cDoubtOpinProject + '\r\n\n'+ cDoubtOpinList[i]
        //         }
        //     }
            
        //     let option = {
        //         "no": this.operatorList[0].reportNo,
        //         "principalName": this.detailData.companyName,
        //         "peoPleName": this.detailData.cInsuredNme,
        //         "conclusion": cConcRstProject1,
        //         "reportGenerationTime": nowTime,

        //        "company": this.detailData.companyName,
        //         "riskTyep": this.detailData.cProdName,
        //         "insurePeople": "",
        //         "policyNo": this.detailData.cPlyNo,
        //         "reportNo": this.detailData.cClmNo,
        //         "outRiskTime": parseTimeD(this.detailData.tAccdntTm),
        //         "outRiskPlace": this.detailData.cAccdntPlace,
        //         "injuredName": "\n\n"+cAccdntPro,

        //         "caseProfile":cAccdntPro,
        //         "entrustedProject": cDoubtOpinProject,
        //         "investigation": investigation,
        //         "conclusionInfo": cConcRstProject2,
        //         // "investigator": this.detailData.zpOperator,//调查员
        //         "investigator": investigatorList,//调查员
                
        //         "issue": localStorage.getItem('name'),//签发人
                
        //     }
        //     let res = await api.getAccident(option);
        //     this.$message({
        //         type: 'success',
        //         message: '生成成功!'
        //     });
        //     this.queryMaterByAnXinDcTaskId();
        // },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        showImgM(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].materialType=='jpg'||list[i].materialType=='png'||list[i].materialType=='gif'||list[i].materialType=='jpeg'||list[i].materialType=='JPG'||list[i].materialType=='PNG'||list[i].materialType=='GIF'||list[i].materialType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        // 查询调查员列表
        // async queryUserByMechanismIds(){
        //     let res  = await api.queryUserByMechanismIds(this.userConditionData);
        //     this.userList = res.data.data.data;
        //     this.userTotalCount = res.data.data.totalCount;
        // },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
         // 机构列表
        selectDataMechanism(){
            this.conditionDataMechanism.page = 1;
            this.queryMechanism();
        },
        resetMechanism(){
            this.conditionDataMechanism = {
                Name:'',
                page:1,
                pageSize:10,
            },
            this.queryMechanism();
        },
        async queryMechanism(){
            let res = await api.QueryMechanism(this.conditionDataMechanism);
            this.mechanismList = res.data.data.data;
            this.totalCountMechanism = res.data.data.totalCount;
        },
        
        handleCurrentChangeMechanism(page){
            this.conditionDataMechanism.page = page;
            this.queryMechanism();
        },

        async queryAnXinFinanceLogByAnXinDcTaskId(){
            let res = await api.queryAnXinFinanceLogByAnXinDcTaskId(this.detailData.id);
            console.log(res);
            this.financeLogList = res.data.data;
        },
        changeTab(e){
            if(e.index==0){
                this.queryAnXinDcTaskByAnXinDcTaskId();

                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            }
            if(e.index==1){
                this.queryAnXinDoubtDetailByAnXinDcTaskId();
            }
            if(e.index==2){
                this.queryAnXinCaseMaterialItemByAnXinDcTaskId();
            }
            if(e.index==3){
                this.queryDoubtTasksByAnXinDcTaskId();
            }
            // if(e.index==4){
            //     this.queryDoubtTasksByAnXinDcTaskId();
            // }
           
            if(e.index==4){
                this.queryAnXinOperationLogByAnXinDcTaskId();
            }
            if(e.index==5){
                this.queryAnXinFinanceLogByAnXinDcTaskId();
            }
        },
        // 调查任务Id查询调查资料
        async queryAnXinCaseMaterialItemByAnXinDcTaskId(){
            let res = await api.queryAnXinCaseMaterialItemByAnXinDcTaskId(this.$route.query.id);
            this.surveyInfo = res.data.data?res.data.data:[];
        },
        // 调查任务Id查询调查信息
        async queryAnXinDoubtDetailByAnXinDcTaskId(){
            let res = await api.queryAnXinDoubtDetailByAnXinDcTaskId(this.$route.query.id);
            this.surveyData = res.data.data;
        },
        // 作业机构
        async queryDoubtTasksByAnXinDcTaskId(){
            let res = await api.queryDoubtTasksByAnXinDcTaskId(this.$route.query.id);
            this.jobAgenciesData=res.data.data;
            if(!this.jobAgenciesData.doubTaskMaterialItems){
                this.jobAgenciesData.doubTaskMaterialItems = [];
            }
            if(!this.jobAgenciesData.doubtCourseList){
                this.jobAgenciesData.doubtCourseList = [];
            }
        },
        // 日志
        async queryAnXinOperationLogByAnXinDcTaskId(){
            let res = await api.queryAnXinOperationLogByAnXinDcTaskId(this.$route.query.id);
            this.logList=res.data.data;
        },
        // 调查信息详情
        surveyDataDetail(row){
            console.log(row);
            this.surveyDataItemDialog = true;
            this.surveyDataItem = row;
        },
        // 指派作业机构
        assignJobAgencies(){
            this.isAssignJobAgencies = true;
        },
        // 选择机构
        selectMechanism(row){
            this.assignJobAgenciesData.operatorMechanismId = row.id;
            this.assignJobAgenciesData.operatorMechanism = row.name;
            this.isMechanismDialog = false;
            this.resetMechanism();
        },
        async affirmMechanism(){
            let option = [];
            if(!this.assignJobAgenciesData.taskFee){
                this.$message({
                    message: '公估费用未填！',
                    type: 'error'
                });
                return;
            }
            option.push({
                anXinDcTaskId:this.detailData.id,
                cDoubtId:this.detailData.cDoubtId,
                operatorMechanism:this.assignJobAgenciesData.operatorMechanism,
                operatorMechanismId:this.assignJobAgenciesData.operatorMechanismId,
                CClmNo:this.detailData.cClmNo,
                CPlyNo:this.detailData.cPlyNo,
                CInsuredNme:this.detailData.cInsuredNme,
                cProdName:this.detailData.cProdName,
                dcyq:this.assignJobAgenciesData.dcyq,
                isZhuPaiJiGou:this.assignJobAgenciesData.isZhuPaiJiGou,
                taskFee:parseFloat(this.assignJobAgenciesData.taskFee)
            })
                
            let res = await api.batchDispatchTaskToOperatorMechanism({
                AnXinDcTaskId:this.detailData.id,
                DispatchDoubtTaskRequest:option
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '指派成功!'
                });
                this.isAssignJobAgencies = false;
                this.queryDoubtTasksByAnXinDcTaskId(this.detailData.id);
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
        },
        // 选择机构
        handleSelectionMechanismChange(e){
            this.selectMechanismList = e;
        },
        // 取消指派
        async cancelAssign(row){
            this.$confirm('将取消指派，是否确认?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.canceDispatchTaskToOperatorMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async canceDispatchTaskToOperatorMechanism(row){
            let res = await api.canceDispatchTaskToOperatorMechanism(row);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已取消成功'
                });  
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },
        // 接受任务
        receiveAnXinDcTaskTip(){
            this.$confirm('确认接受任务, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.receiveAnXinDcTask();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async receiveAnXinDcTask(){
            let res = await api.receiveAnXinDcTask({
                id:this.$route.query.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '接受成功'
                });  
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
        },
        // 设为主派机构
        async setZhuPaiMechanismTip(row){
            console.log(row);
            this.$confirm('设置为主派机构, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.setZhuPaiMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async setZhuPaiMechanism(row){
            let res = await api.setZhuPaiMechanism({
                id:row.id
                // anXinDcTaskId: row.anXinDcTaskId,
                // zpMechanismId: row.operatorMechanismId,
                // zpMechanismName: row.operatorMechanism
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '设置成功'
                });  
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },
        // 设置主派人员
         async setZhuPaiOperator(row){
            console.log(row);
            let res = await api.setZhuPaiOperator({
                id:row.id
            });
            if(res.data.code == '200') {
                this.$message({
                    message: '设置成功',
                    type: 'success'
                });
                this.JgDetail();
            }
        },
        // 机构人员列表
        async JgDetail(row){
            this.isPersonTaskDialog = true;
            if(row){
                this.mechanismId = row.id;
                this.jgRwId = row.id;
            }
            let res = await api.queryDoubtTaskItemByDoubtTaskId(this.mechanismId);
            this.personTaskList = res.data.data;
            this.personTaskTitle = row.operatorMechanism+'——调查员';
            
        },
        async personDetail(row){
            console.log(row);
            console.log(this.personId);
            if(row){
                this.personId = row.id?row.id:this.personId
            }
            this.isPersonInfoDialog = true;
            let res = await api.queryDoubtTaskItemById(this.personId);
            let doubTaskMaterialItems = res.data.data.doubTaskMaterialItems;
            this.personDoubtCourseList = res.data.data.doubtCourseList;
            let name = '';
            this.personMaterialList = [];
            for(let i in doubTaskMaterialItems){
                if(name!=doubTaskMaterialItems[i].name){
                    name = doubTaskMaterialItems[i].name;
                    this.personMaterialList.push([]);
                }
                this.personMaterialList[this.personMaterialList.length-1].push(doubTaskMaterialItems[i]);
            }
        },
        
        
        // 提交安心
        doubtTaskCompleteTip(){
            this.$confirm('将提交安心, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.doubtTaskComplete();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async doubtTaskComplete(){
            this.taskReasonData.id = this.$route.query.id;
            let res = await api.doubtTaskComplete(this.taskReasonData);
            if(res.data.code == '200'){
                // this.$message({
                //     type: 'success',
                //     message: '上传成功!'
                // });
                this.anXinDcTaskUploadFile();
                this.isTaskReason=false;
            }
        },
        async anXinDcTaskUploadFile(){
            let res = await api.anXinDcTaskUploadFile({
                id:this.detailData.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '上传成功!'
                });
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
        },

        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismIds();
        },


        
        
        deleteCCourTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.$index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        deleteCCour(index){
            this.jobAgenciesData.doubtCourseList.splice(index,1);
            this.$message({
                type: 'success',
                message: '已删除成功'
            });    
        },
        // 调查任务Id查询调查信息
        async queryAnXinDcTaskByAnXinDcTaskId(){
            let res = await api.queryAnXinDcTaskByAnXinDcTaskId(this.$route.query.id);
            this.detailData = res.data.data;
            // this.detailData.cDoubtOpin = this.detailData.cDoubtOpin.replace(/\n/g,"<br>");
            
            if(this.detailData.cDoubtOpin){
                this.cDoubtOpinList = this.detailData.cDoubtOpin.split(/\n/g)
            }else{
                this.cDoubtOpinList
            }
            this.$forceUpdate();
            console.log(this.detailData.cDoubtOpin);
            // this.detailData.doubtCourseList = this.detailData.doubtCourseList?this.detailData.doubtCourseList:[]
            // this.detailData.doubTaskMaterialItems = this.detailData.doubTaskMaterialItems?this.detailData.doubTaskMaterialItems:[]
            
            document.title = '意健险——'+this.detailData.cInsuredNme
            if(this.detailData.dcTaskAction==10){
                this.stepsActive = 1;
            }else if(this.detailData.dcTaskAction==20){
                this.stepsActive = 2;
            }else if(this.detailData.dcTaskAction==25){
                this.stepsActive = 3;
            }else if(this.detailData.dcTaskAction==30){
                this.stepsActive = 4;
            }else if(this.detailData.dcTaskAction==60){
                this.stepsActive = 5;
            }else if(this.detailData.dcTaskAction==50){
                this.stepsActive = 6;
            }

        },
        // 确认编辑
        async edit(){
            this.detailData.nRefusePayAmt = parseFloat(this.detailData.nRefusePayAmt);
            this.detailData.nDeroAmt = parseFloat(this.detailData.nDeroAmt);
            let res = await api.updateTaskInfo(this.detailData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
        },
        // 提交审核
        async examineTask(status){
            if(status==20){
                this.isNoPersonAudit = true;
                return;
            }
            this.$confirm('是否确认审核通过?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.examineTaskApi(status);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async examineTaskApi(status){
            let option = {
                id:this.personId,
                auditStatus:status,
                taskReason:this.personTaskReason
            };
            let res  = await api.updateAuditStatus(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.isNoPersonAudit = false;
                this.isPersonInfoDialog = false;
                this.JgDetail();
            }
            this.queryAnXinDcTaskByAnXinDcTaskId();
        },
        
        // 上传
        async uploadCPath(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            this.addCaseMaterial.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterial.path = res;
            this.$forceUpdate();
            console.log(res);

        },
        // 添加调查资产
        // addCaseMaterialF(){
        //     this.surveyInfo.push(this.addCaseMaterial);
        //     // this.detailData.doubTaskMaterialItems.push(this.addCaseMaterial);
        //     this.isAddCaseMaterial = false;
        //     console.log(this.detailData.doubTaskMaterialItems);
        //     this.$forceUpdate();
        // },
        // 下载资料
        download(path,name){
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        deleteDoubTaskMaterialItemTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.$index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        deleteDoubTaskMaterialItem(index){
            this.detailData.doubTaskMaterialItems.splice(index,1);
            this.$message({
                type: 'success',
                message: '已删除成功'
            });   
        },

        backForUpdateTip(){
            this.isNoAudit = true;
        },
        async backForUpdate(){
            let res = await api.backForUpdate({
                id:this.detailData.id,
                thirdId:this.detailData.cDoubtId,
                reason:this.reason,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '拒绝成功'
                });  
                this.isNoAudit = false;
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
        },
        // 审核不通过
        noAuditTip(){
            this.isNoAuditDialog = true;
        },
        async noAuditApi(){
            let res = await api.anXinDcTaskReturnTask({
                "anXinDcTaskId": this.detailData.id,
                "returnReason": this.returnReason
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '退回成功'
                });  
                this.returnReason = '';
                this.isNoAuditDialog = false;
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
        },
        // 审核
        
        async auditBack(){
            let option = {
                id:this.auditBackData.id,
                auditStatus:50,
                taskReason:this.taskReason,
            };
            
            let res  = await api.updateAuditStatusDoubtTask(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.taskReason = '';
                this.isAuditBackDialog = false;
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },

        passAuditTip(){
            this.$confirm('将确定通过, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.passAudit();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async passAudit(){
            this.taskReasonData.id = this.$route.query.id;
            let res = await api.doubtTaskComplete(this.taskReasonData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });
                this.queryAnXinDcTaskByAnXinDcTaskId();

            }
        },
       

        async cProcessDetail(detail){
            console.log(detail);
            this.cProcess = detail;
            this.cProcessDetailDialog = true;
        },

        // 添加调查节点成功
        async addDoubtCourseF(){
            if(!this.addDoubtCourse.dcTaskSubJect){
                this.$message({
                    type: 'warning',
                    message: '调查节点不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cCourAddr){
                this.$message({
                    type: 'warning',
                    message: '调查省级市不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cCourMode){
                this.$message({
                    type: 'warning',
                    message: '案件类型不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cCourOperNme){
                this.$message({
                    type: 'warning',
                    message: '被调查人姓名不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cCourPlace){
                this.$message({
                    type: 'warning',
                    message: '调查地点不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cCourPro){
                this.$message({
                    type: 'warning',
                    message: '调查项目不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cCourRela){
                this.$message({
                    type: 'warning',
                    message: '被调查人与被保人关系不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.cProcess){
                this.$message({
                    type: 'warning',
                    message: '调查过程不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.tCourTm){
                this.$message({
                    type: 'warning',
                    message: '调查时间不能为空!'
                });
                return;
            }
            this.addDoubtCourse.tCourTm = parseTimeS(this.addDoubtCourse.tCourTm);
            this.addDoubtCourse.anXinDcTaskId = this.$route.query.id;
            let res = await api.doubtCourseAddRange([this.addDoubtCourse]);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.addDoubtCourse = {
                    cCourAddr:null,
                    cCourAll:null,
                    cCourMode:null,
                    cCourOperNme:null,
                    cCourPlace:null,
                    cCourPro:null,
                    cCourRela:null,
                    cProcess:null,
                    tCourTm:null,
                };
                this.selectedOptions = null;
                this.isAddDoubtCourse = false;
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            }
        },
        deleteCCourTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCCour(id){
            let res = await api.doubtCourseDelete(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            } 
        },
        
        // 调查信息
        async queryDoubtTaskItem_CourseByAnXinDcTaskId(){
            let res = await api.queryDoubtTaskItem_CourseByAnXinDcTaskId(this.$route.query.id);
            if(res.data.code == '200'){
                this.doubtCourseList = res.data.data;
            }
        },
        async queryByAnXinDcTaskIdExcludeDoubtTaskItem(){
            let res = await api.queryByAnXinDcTaskIdExcludeDoubtTaskItem(this.$route.query.id);
            if(res.data.code == '200'){
                this.otherDoubtCourseList = res.data.data;
            }
        },

        // 指派人员
        assignPersonTip(row){
            console.log(row);
            this.assignPersonData.cDoubtId =row.cDoubtId;
            this.assignPersonData.cClmNo =row.cClmNo;
            this.assignPersonData.cPlyNo =row.cPlyNo;
            this.assignPersonData.cInsuredNme =row.cInsuredNme;
            this.assignPersonData.cProdName =row.cProdName;
            this.assignPersonData.doubtTaskId = row.id;
            this.mechanismId = row.operatorMechanismId;

            this.zpjg = row.isZhuPaiJiGou;
            this.isAssignPerson = true;
        },
        async affirmPerson(){
            let res = await api.assignTaskToOperator(this.assignPersonData);
            if(res.data.code == '200') {
                this.$message({
                    message: '指派成功',
                    type: 'success'
                });
                this.isAssignPerson = false;
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
        // 选择人员
        async selectOperator(row){
            this.userDialog = true;
            this.queryUserByMechanismId();
        },
        // 人员列表
        async queryUserByMechanismId(){
            this.userConditionData.MechanismIds = [this.mechanismId]

            let res = await api.QueryUsers(this.userConditionData);
            // let res = await api.queryUserByMechanismId(this.mechanismId);
            if(res.data.data){
                this.userList = res.data.data.data;
                this.userTotalCount = res.data.data.totalCount;
            }
            
        },

        selectPerson(row){
            this.assignPersonData.operator = row.name;
            this.assignPersonData.operatorId = row.id;
            this.userDialog = false;
        },

        // 取消指派
        async cancelAssignPerson(row){
            this.$confirm('将取消指派，是否确认?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubtTaskItem(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async deleteDoubtTaskItem(id){
            let res = await api.deleteDoubtTaskItem(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已取消成功'
                });  
                this.JgDetail();
            }
        },

        // 添加调查资料
        async addSurveyInfo(file){
            let material = {
                anXinDcTaskId:this.detailData.id,
                materialType:'',
                name:'',
                path:'',
            };
            material.name = file.file.name;
            let fileTypeList = material.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.materialType = fileType;
            let res = await api.uploadOther(file.file);
            material.path = res;
            if(this.surveyInfo){
                this.surveyInfo.push(material);
            }else{
                this.surveyInfo=[material];
            }
        },

        async editSurveyInfo(){
            let res = await api.addAnXinCaseMaterialItem({materialItems:this.surveyInfo});
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });  
            }
        },
        clearSurveyInfoMaterial(index){
            this.surveyInfo.splice(index,1);
        },

        // 新增调查信息
        addSurveyDataFun(){
            console.log(this.addSurveyData);
            
            this.surveyData.push({
                cSvyNeed:this.addSurveyData.cSvyNeed,
                cSvyNeedCode:this.addSurveyData.cSvyNeed,
                tHopeEndTm:this.addSurveyData.tHopeEndTm,
                cSvyType:this.addSurveyData.cSvyType,
                cSvyTypeCode:this.addSurveyData.cSvyTypeCode,
                cSvyMode:this.addSurveyData.cSvyMode,
                cSvyModeCode:this.addSurveyData.cSvyModeCode,
                cSvyPlace:this.addSurveyData.cSvyPlace,
                cSvyPlaceCode:this.addSurveyData.cSvyPlaceCode,
                cSvyAddr:this.addSurveyData.cSvyAddr,
            });
            this.addSurveyDataDialog = false;
            this.updateAnXinDcTask();
            this.$forceUpdate();
        },
        // 编辑调查信息
        editSurveyDataFun(){
            console.log(this.surveyDataItem);
            this.surveyData[this.surveyDataIndex] = this.surveyDataItem;
            this.surveyDataItemDialog = false;
            this.updateAnXinDcTask();
            this.$forceUpdate();
        },
        async updateAnXinDcTask(){
            this.addSurveyData = {};

            this.detailData.materialItems = this.surveyInfo;
            this.detailData.anXinDoubtDetails = this.surveyData;
            let res = await api.updateAnXinDcTask(this.detailData);
            if(res.data.code == '200'){
                this.queryAnXinDoubtDetailByAnXinDcTaskId();

                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });  
                this.surveyDataItemDialog = false;
                
            }
        },
        // 调查信息查询
        surveyDataItemDialogOpen(detail,index){
            console.log(index);
            this.surveyDataIndex = index;
            this.surveyDataItemDialog = true;
            this.surveyDataItem = detail;
        },
        changeCSvyPlace(e){
            for(let index in this.cSvyPlaceList){
                if(this.cSvyPlaceList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyPlace = this.cSvyPlaceList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyPlace = this.cSvyPlaceList[index].label
                    }
                    return;
                }
            }
        },
        changeCSvyNeed(e){
            for(let index in this.cSvyNeedList){
                if(this.cSvyNeedList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyNeed = this.cSvyNeedList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyNeed = this.cSvyNeedList[index].label
                    }
                    return;

                }
            }
        },
        changeCSvyType(e){
            for(let index in this.cSvyTypeList){
                if(this.cSvyTypeList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyType = this.cSvyTypeList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyType = this.cSvyTypeList[index].label
                    }
                    return;

                }
            }
        },
        changeCSvyMode(e){
            for(let index in this.cSvyModeList){
                if(this.cSvyModeList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyMode = this.cSvyModeList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyMode = this.cSvyModeList[index].label
                    }
                    return;

                }
            }
        },


        // 查看过程
        editCCour(row){
            console.log(row);
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
                query:{
                    id:scope.row.id,
                    stepsActive:true,
                    anXinDcTaskId:row.anXinDcTaskId,
                    doubtTaskItemId:row.doubtTaskItemId,

                }
            });
            window.open(href, '_blank');
        },
        // 删除调查过程
        deleteCCourPerson(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCCourApi(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        
        async deleteCCourApi(row){
            let res = await api.deleteDoubtCourseList({
                id:row.id,
                doubtTaskItemId:row.doubtTaskItemId,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.personDetail();

            }
           
        },

        deleteCCourAll(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCCourAllApi(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCCourAllApi(row){
            let res = await api.deleteDoubtCourseList({
                id:row.id,
                doubtTaskItemId:row.doubtTaskItemId,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
            }
           
        },

        // 添加其他资料
        async addOtherMaterial(file){
            if(!this.addCaseMaterial.name){
                this.$message({
                    type: 'warning',
                    message: '请先填写资料名称!'
                });
                return;
            }
            let name = this.addCaseMaterial.name;
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );

            if(fileType=='jpg'||fileType=='png'||fileType=='gif'||fileType=='jpep'||fileType=='xlsx'||fileType=='doc'||fileType=='docx'||fileType=='ppt'||fileType=='pptx'){
                if(file.file.size>(1024*1024*10)){
                    this.$message({
                        type: 'error',
                        message: '图片和文档不能超过10MB!'
                        // message: '图片和文档只能上传jpg，png，gif，jpep，xlsx，doc，docx，ppt，pptx，pdf，zip，rar；且不能超过10MB!'
                    });
                    return;
                }
            }else if(fileType=='pdf'||fileType=='zip'||fileType=='rar'){
                if(file.file.size>(1024*1024*500)){
                    this.$message({
                        type: 'error',
                        message: '文件不能超过500MB'
                    });
                    return;
                }
            }else if(fileType=='rmvb'||fileType=='rm'||fileType=='ts'||fileType=='tp'||fileType=='avi'||fileType=='3gp'||fileType=='mp4'||fileType=='mkv'){
                if(file.file.size>(1024*1024*500)){
                    this.$message({
                        type: 'error',
                        message: '视频不能超过500MB'
                    });
                    return;
                }
            }else if(fileType=='mp3'||fileType=='aac'||fileType=='wav'||fileType=='wma'||fileType=='flac'||fileType=='ape'){
                if(file.file.size>(1024*1024*100)){
                    this.$message({
                        type: 'error',
                        message: '音频不能超过100MB'
                    });
                    return;
                }
            }else{
                this.$message({
                    type: 'error',
                    message: '不支持上传格式'
                });
                return;
            }
            this.allNum = this.allNum+1;


            let res = await api.uploadOther(file.file);
            let path = res;
            this.addOtherMaterialList.push({
                fileType:fileType,
                fileName:file.file.name,
                doubtTaskItemId:this.personId,
                name:name,
                path:path,
            });
            this.finishNum = this.finishNum+1;
            console.log(this.addOtherMaterialList);
            this.$forceUpdate();
        },

        async addOtherMaterialApi(){
            let res = await api.addDoubTaskMaterialItems({
                operatorId:this.allOperatorId,
                operator:this.allOperator,
                doubtTaskId:this.jgRwId,
                doubTaskMaterialItems:this.addOtherMaterialList
            });
            if(res.data.code='200'){
                this.isAddOtherMaterialDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });     
                this.finishNum=0;
                this.allNum=0;
                this.addOtherMaterialList = [];
                this.personDetail();
            }

        },

        async addOtherMaterialDialog(){
            this.isAddOtherMaterialDialog = true;
            let res = await api.queryOperatorByDoubtTaskId(this.jgRwId);
            this.personTaskList = res.data.data;

        },

        async clearOtherMaterial(item){
            this.$confirm('确认删除资料, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.clearOtherMaterialApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async clearAllItemMaterial(item){
            this.$confirm('确认删除资料, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.clearAllItemMaterialApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async clearOtherMaterialApi(item){
            let res = await api.deleteDoubTaskMaterialItems({
                doubtTaskItemId:item.doubtTaskItemId,
                id:item.id,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });     
                this.personDetail();
            }
        },
        async clearAllItemMaterialApi(item){
            let res = await api.deleteDoubTaskMaterialItems({
                doubtTaskItemId:item.doubtTaskItemId,
                id:item.id,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });     
                this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();
            }
        },
        // 选择调查人员
        changeAddDoubtCourseOperator(e){
            console.log(e);
            for(let index in this.personTaskList){
                if(e == this.personTaskList[index].operatorId){
                    this.allOperatorId = e;
                    this.allOperator = this.personTaskList[index].operator;
                }
            }
        },
        

        handleRegionChange(){
            let e = this.selectedOptions;
            if(e[2]){
                this.addDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]+'-'+CodeToText[e[0],e[1],e[2]]
            }else if(e[1]){
                this.addDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]
            }
            this.addDoubtCourse.cCourAll=this.selectedOptions;
            for(let index in this.selectedOptions){
                this.addDoubtCourse.cCourAll[index] = parseInt(this.selectedOptions[index]);
            }
            console.log(this.addDoubtCourse);
        },

        async restarUpload(item){
            console.log(item);
            let res = await api.restartUploadDoubTaskMaterialItem({
                "doubtTaskItemId": item.doubtTaskItemId,
                "id": item.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '上传成功'
                });   
                this.queryDoubtTaskItemMaterialItemByAnXinDcTaskId();
            }
        },
        // 打开资料
        changeIsOpen(index){
            console.log(this.allMaterialList[index]);
            this.allMaterialList[index].isOpen = this.allMaterialList[index].isOpen==true?false:true;
            this.$forceUpdate();
        },
        // 编辑调查结论
        async updateCccnn(){
            let res = await api.UpdateCccnn({
                anXinDcTaskId:this.detailData.id,
                cConclusion:this.detailData.cConclusion,
                cConcRst:this.detailData.cConcRst,
                cRefuseRsn:this.detailData.cRefuseRsn,
                nRefusePayAmt:parseFloat(this.detailData.nRefusePayAmt?this.detailData.nRefusePayAmt:0),
                nDeroAmt:parseFloat(this.detailData.nDeroAmt?this.detailData.nDeroAmt:0),
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
                    
        },

        async downFileAnXinDcTask(){
            let res = await api.downFileAnXinDcTask(this.detailData.id,{
                zipName:'调查资料'
            });

            // let res = await api.jsDownFileAnXinDcTask(this.detailData.id);
            // if(res.data.code == '200'){
            //     batchDownloadList(res.data.data)
            // }
        },
        async downloadSurveyInfo(){
            for(let i in this.surveyInfo){
                let pathList = this.surveyInfo[i].path.split('.');
                if(pathList.length==1){
                    this.surveyInfo[i].path = this.surveyInfo[i].path+'.'+this.surveyInfo[i].materialType
                }
            }
            batchDownload(this.surveyInfo)
            // let res = await api.downFileAnXinPgDcTask(this.detailData.id,{
            //     zipName:'派工资料'
            // });
        },

        async appraisalFeeChange(){
            let res = await api.setDcTaskAppraisal({
                "anXinDcTaskId":this.detailData.id,
                "appraisalFee": parseFloat(this.detailData.appraisalFee)
            });
            if(res.data.code=="200"){
                this.$message({
                    type: 'success',
                    message: '编辑公估费成功!'
                });
            }
        },


        editTaskFeeTip(row){
            this.editTaskFeeData.doubtTaskId = row.id;
            this.editTaskFeeData.taskFee = row.taskFee;
            this.editTaskFeeData.rewardFee = row.rewardFee;
            this.editTaskFeeData.taskFeeReason = row.taskFeeReason;
            this.editTaskFeeData.dcyq = row.dcyq;
            this.editTaskFeeData.isZhuPaiJiGou = row.isZhuPaiJiGou;

            this.isEditTaskFeeTip = true;
        },
        async editTaskFee(){
            if(!this.editTaskFeeData.taskFee&&this.editTaskFeeData.taskFee!='0'){
                this.$message({
                    message: '公估费用未填！',
                    type: 'error'
                });
                return;
            }
            if(this.editTaskFeeData.taskFee == '0'){
                if(!this.editTaskFeeData.taskFeeReason){
                    this.$message({
                        message: '公估费用为0原因未填！',
                        type: 'error'
                    });
                    return;
                }
            }
            this.editTaskFeeData.rewardFee = parseFloat(this.editTaskFeeData.rewardFee);
            this.editTaskFeeData.taskFee = parseFloat(this.editTaskFeeData.taskFee);
            let res = await api.updateTaskFee(this.editTaskFeeData);
            if(res.data.code=="200"){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.isEditTaskFeeTip = false;
                this.queryDoubtTasksByAnXinDcTaskId();

            }
        },

        // 申请加派
        async applyDispatch(){
            if(this.doubtCourseList.length==0){
                this.$message({
                    type: 'warning',
                    message: '调查过程不能为空'
                }); 
                return;
            }
            
            this.applyDispatchData.anXinDcTaskId = this.detailData.id;
            this.applyDispatchData.isJpyq = true;
            let res = await api.setDcTaskJpyq(this.applyDispatchData);
            if(res.data.code == '200'){
                this.doubtTaskComplete();
                this.isApplyDispatchTip = false;
            }
        },


        async querySearch(queryString, cb){
            let list = this.cSvyNeedList;
            console.log(queryString);
            let results = queryString ? list.filter(this.createFilter(queryString)) : list;
            console.log(results);
            cb(results);
        },
        handleSelect(e){
            console.log(e);
            if(this.surveyDataItemDialog){
                this.surveyDataItem.cSvyNeed = e.label;
                this.surveyDataItem.cSvyNeedCode = e.label;
            }else if (this.addSurveyDataDialog) {
                this.addSurveyData.cSvyNeed = e.label;
                this.addSurveyData.cSvyNeedCode = e.label;
            }
        },
        createFilter(queryString) {
            return (list) => {
                return (list.label.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
            };
        },

        // 是否展开
        changeIsOpen(index){
            this.doubtCourseList[index].isOpen = this.doubtCourseList[index].isOpen==true?false:true;
            this.$forceUpdate();
        },
        // 编辑调查过程
        editCCourTip(scope){
            console.log(scope.row);
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
                query:{
                    id:scope.row.id,
                    stepsActive:true,
                    anXinDcTaskId:scope.row.anXinDcTaskId,
                    doubtTaskItemId:scope.row.doubtTaskItemId,

                }
            });
            window.open(href, '_blank');
           
        },
        detailCCour(scope){
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
                query:{
                    id:scope.row.id,
                    stepsActive:false,
                    anXinDcTaskId:scope.row.anXinDcTaskId,
                    doubtTaskItemId:scope.row.doubtTaskItemId,

                }
            });
            window.open(href, '_blank');
        },



        async noAgree(row){
            this.$confirm('再次确认不同意?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.canceDispatchTaskToOperatorMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },

        async canceDispatchTaskToOperatorMechanism(row){
            let res = await api.canceDispatchTaskToOperatorMechanism(row);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },
        async updateExecuteAction(row){
            let res = await api.excuteExecuteActionDoubtTask(row.id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        display: flex;
        align-items: center;
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
    .top{
        width:100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding:10px 0;
        // top:60px;
        top:0px;
        left:0px;
        background-color: #ffffff;
        position:fixed;
        z-index: 60;
        /deep/.el-step__title{
           font-weight: bold; 
        }
        
    }
    .index{
        padding:0 10px;
        padding-top:60px;
    }
    .handle{
        margin-bottom: 10px;
    }
    .dialog-btn{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .section{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .title-s{
            display: flex;
            justify-content: space-between;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
                display: flex;
                align-items: center;
                .dot{
                    color: red;
                    font-size: 20px;
                }
            }
            .value{
                width: 220px;
                .value-textarea{
                    border:1px solid #DCDFE6;
                    width: 564px;
                    min-height: 50px;
                    border-radius: 4px;
                    padding: 5px 14px;
                    font-size: 13px;
                    line-height: 24px;
                }
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }
    
    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
        }
        .inline-input{
            width: 100%;
        }
        .value{
            width: 220px;
            display: flex;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        align-items: center;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            padding-top: 15px;
            padding-bottom: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            float: left;
            span{
                display: flex;
                flex-wrap: wrap;
            }
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
            .el-button--mini, .el-button--mini.is-round{
                padding-bottom: 0px;
                padding-top: 4px;
            }
        }
    }
    .section-btns{
        width: 100%;
        display: flex;
        justify-content: center;
        /deep/.el-button{
            margin: 0 20px;
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
       
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .stitle-l{
                display: flex;
                align-items: center;
            }
            span{
                font-size: 14px;
                font-weight: 500;
                margin: 0 10px;
            }
            .stitle-r{
                font-weight: 400;
                color:blue;
                font-size: 13px;
            }
        }
        i{
            font-size: 20px;
            font-weight: bold;
            margin-left: 10px;
            cursor: pointer;
        }
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 14px;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
</style>
